function resetBrandFilters() {
  this.$data.settings.filters.brandsSelected = false;
  this.$data.settings.filtersText.brandsText = false;
  this.$data.settings.filtersValues.brandsVal = [];
}
export default resetBrandFilters;
